import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import Joyride from 'react-joyride';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  addQuoteTravelToCart,
  loadTravelQuotes,
  removeQuoteTravelFromCart,
  resetTravelQuotes,
  updateTravelGuarantee,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
// import { SellingDistanceLink } from '../../common/components/elements/SellingDistanceLink';
// import { SellingDistanceModal } from '../../common/components/elements/SellingDistanceModal/SellingDistanceModal';
// import axe from '../../services/axios-client/axiosClient';
import { TravelQuotesStyles } from './TravelResultPage.styles';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import { AvvisoAlert } from '../RcQuotes.styles';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackTravelResult } from '../../common/utils/joyrideCallbacks';
// import { travelResultSteps } from '../../common/utils/joyrideSteps';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import TravelSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/TravelSummaryCard';
import TravelQuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/TravelQuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import {
  RiskButton,
  RiskButtonRemove,
  RiskCard,
  RiskContainer,
  SelectFirstNotice,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
// import AragCard from '../../common/components/redesignComponents/Cards/AragCard';
import ProcessingQuoteSelectedTravel from '../../common/components/redesignComponents/ResultPageComponents/ProcessingQuoteSelectedTravel';
import GuaranteesSelectedCard from '../../common/components/redesignComponents/Cards/GuaranteesSelectedCard';
import quotationsAxe from '../../services/axios-client/quotationsAxeClient';
import ProductInformationMondo from './parts/ProductInformationMondo';
import ProductInformationEurope from './parts/ProductInformationEurope';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import TravelModal from './parts/TravelModal';
import TravelCoverageModal from './parts/TravelCoverageModal';
import FailedQuotationsComponent from '../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

// import TutelaSelectedTravel from '../../common/components/redesignComponents/ResultPageComponents/TutelaSelectedTravel';

const schema = yup.object({
  infortuni_data: yup.object({
    value: yup.string().required(),
    beneficario: yup.string().nullable(),
    contractor_id: yup.number().nullable(),
    insured_id: yup.number().nullable(),
  }),
});

function TravelResultPage() {
  const { requestToken } = useParams();
  const {
    loading,
    customer,
    insuranceRequest,
    failedQuotations,
    error,
    quotes,
    processingQuote,
    riskQuotations,
    addingQuote,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.travel_quotes);
  const navigate = useNavigate();
  const [showConversationModal, setShowConversationModal] = useState(false);
  // const [showSellingDistanceModal, setShowSellingDistanceModal] = useState(false);
  const [modalExtensions, setModalExtensions] = useState([]);
  // const [showForm, setShowForm] = useState(false);
  const [loadingDataset, setLoadingDataset] = useState(false);

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const modifyData = () => {
    navigate('/quote/travel', {
      state: { requestToken },
    });
  };

  const {
    register, watch, reset,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: {
      infortuni_data: {
        value: '',
        beneficario: '',
        contractor_id: '',
        insured_id: '',
      },
    },
  });

  const formData = watch();

  const silentRefresh = () => loadTravelQuotes(requestToken);

  // const [steps, setSteps] = useState([]);

  // const generateSellingDfirstceLink = async () => {
  //   const res = await axe.post(`/selling-distance/${requestToken}`);

  //   if (res.status !== 200) {
  //     generalAlertError('Non siamo riusciti a generare il collegamento');
  //     return;
  //   }

  //   generalAlertSuccess('Il collegamento e stato creato');

  //   loadTravelQuotes(requestToken);
  // };

  // const getSellingDistanceLink = () => `${SELLING_DISTANCE_URL}/request/${insuranceRequest.distance_token}/travel/results`;

  // const copySellingDistanceLink = async () => {
  //   try {
  //     const link = getSellingDistanceLink();

  //     await navigator.clipboard.writeText(link);
  //     generalAlertSuccess('Il collegamento e stato copiato');
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('newResultTravel') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('newResultTravel')]);

  // const firePurchaseTour = () => {
  //   localStorage.removeItem('newResultTravel');
  //   setState({ run: true });
  // };

  const getCoveragePrice = (coverage) => {
    const groupCoverages = [];
    const travelGuarantees = processingQuote.quotation_data_travel_europeassistance.coverages;
    if (coverage.group_id !== null) {
      const group = travelGuarantees.filter((c) => c.group_id === coverage.group_id);

      groupCoverages.push(...group);
    } else {
      groupCoverages.push(coverage);
    }

    let price = 0;
    for (let x = 0; x < groupCoverages.length; x++) {
      const cov = groupCoverages[x];
      price += cov.coverage_amount_gros;
    }

    return price;
  };

  const updateDataSet = () => {
    setLoadingDataset(true);
    quotationsAxe.put(`/guarantees/travel/${requestToken}/update-dataset`, formData);
    // setShowForm(false);
    setLoadingDataset(false);
    reset();
  };

  const removeDataSet = () => {
    setLoadingDataset(true);
    quotationsAxe.put(`/guarantees/travel/${requestToken}/update-dataset`, { infortuni_data: null });
    // setShowForm(false);
    setLoadingDataset(false);
    reset();
  };

  const fetchQuotes = () => {
    loadTravelQuotes(requestToken);
  };

  const addGuarantees = (quote_id, coverages, closeId) => {
    updateTravelGuarantee(quote_id, coverages, requestToken);
    const dismissButton = document.getElementById(closeId);

    // Trigger a click event on the button
    if (dismissButton) {
      dismissButton.click();
    }
    fetchQuotes();
  };

  const updateGuarantees = (val, closeId) => {
    if (modalExtensions.find((ext) => ext === val)) {
      if (processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.find((el) => el.coverage_id === val).title === 'Bagaglio') {
        const bagaglioTop = processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.find((cov) => cov.title.toLowerCase() === 'bagaglio top');
        if (modalExtensions.includes(bagaglioTop.coverage_id)) {
          let newArr = [];
          newArr = modalExtensions.filter((item) => item !== bagaglioTop.coverage_id);
          setModalExtensions([...newArr, val]);
          addGuarantees(processingQuote.id, [...newArr, val], closeId);
        } else {
          setModalExtensions(modalExtensions.filter((item) => item !== val));

          addGuarantees(processingQuote.id, modalExtensions.filter((item) => item !== val), closeId);
          // if ((val === '000001_EA1358' && !modalExtensions.find((ext) => ext === '000001_EA1358')) || (val === '000001_EA1244' && !modalExtensions.find((ext) => ext === '000001_EA1244'))) {
          //   // document.getElementById('open-modal').click();
          //   // setShowForm(true);
          // }
        }

        return;
      }

      if (processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.find((el) => el.coverage_id === val).title.toLowerCase() === 'bagaglio top') {
        const bagaglio = processingQuote.quotation_data_travel_europeassistance.coverages.find((cov) => cov.title === 'Bagaglio');
        if (modalExtensions.includes(bagaglio.coverage_id)) {
          let newArr = [];
          newArr = modalExtensions.filter((item) => item !== bagaglio.coverage_id);
          setModalExtensions([...newArr, val]);
          addGuarantees(processingQuote.id, [...newArr, val], closeId);
        } else {
          setModalExtensions(modalExtensions.filter((item) => item !== val));

          addGuarantees(processingQuote.id, modalExtensions.filter((item) => item !== val), closeId);
        }
      } else {
        setModalExtensions(modalExtensions.filter((item) => item !== val));

        addGuarantees(processingQuote.id, modalExtensions.filter((item) => item !== val), closeId);
        // if ((val === '000001_EA1358' && !modalExtensions.find((ext) => ext === '000001_EA1358')) || (val === '000001_EA1244' && !modalExtensions.find((ext) => ext === '000001_EA1244'))) {
        //   // document.getElementById('open-modal').click();
        //   // setShowForm(true);
        // }
      }

      return;
    }

    if (processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.find((el) => el.coverage_id === val).title === 'Bagaglio') {
      const bagaglioTop = processingQuote.quotation_data_travel_europeassistance.coverages.find((cov) => cov.title.toLowerCase() === 'bagaglio top');

      if (modalExtensions.includes(bagaglioTop.coverage_id)) {
        let newArr = [];
        newArr = modalExtensions.filter((item) => item !== bagaglioTop.coverage_id);
        setModalExtensions([...newArr, val]);
        addGuarantees(processingQuote.id, [...newArr, val], closeId);
      } else {
        setModalExtensions([...modalExtensions, val]);
        addGuarantees(processingQuote.id, [...modalExtensions, val], closeId);
        // if ((val === '000001_EA1358' && !modalExtensions.find((ext) => ext === '000001_EA1358')) || (val === '000001_EA1244' && !modalExtensions.find((ext) => ext === '000001_EA1244'))) {
        //   // document.getElementById('open-modal').click();
        //   // setShowForm(true);
        // }
      }
      return;
    }

    if (processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.find((el) => el.coverage_id === val).title.toLowerCase() === 'bagaglio top') {
      const bagaglio = processingQuote.quotation_data_travel_europeassistance.coverages.find((cov) => cov.title === 'Bagaglio');
      if (modalExtensions.includes(bagaglio.coverage_id)) {
        let newArr = [];
        newArr = modalExtensions.filter((item) => item !== bagaglio.coverage_id);
        setModalExtensions([...newArr, val]);
        addGuarantees(processingQuote.id, [...newArr, val], closeId);
      } else {
        setModalExtensions([...modalExtensions, val]);
        addGuarantees(processingQuote.id, [...modalExtensions, val], closeId);
      }
    } else {
      setModalExtensions([...modalExtensions, val]);
      addGuarantees(processingQuote.id, [...modalExtensions, val], closeId);
      // if ((val === '000001_EA1358' && !modalExtensions.find((ext) => ext === '000001_EA1358')) || (val === '000001_EA1244' && !modalExtensions.find((ext) => ext === '000001_EA1244'))) {
      //   // document.getElementById('open-modal').click();
      //   // setShowForm(true);
      // }
    }
  };

  const handleGuarantees = (coverageId, idToClose) => {
    // ? Step 1 CHeck if infortuni viaggi
    // ? If infortuni viaggi check if form is filled
    // ? If is filled updateDataset then update guarantees
    // ? if other guarantee type
    // ? update guarantees only

    // ? updateGuarantees(coverageId)
    // ? updateDataset
    if (coverageId === '000001_EA1358' || coverageId === '000001_EA1244') {
      if (formData.infortuni_data.value === '1' || (formData.infortuni_data.value === '2' && formData.infortuni_data.beneficario !== '')) {
        updateDataSet();
        updateGuarantees(coverageId, idToClose);
      } else {
        generalAlertError('Seleziona Prima Beneficiario');
      }
    } else {
      updateGuarantees(coverageId, idToClose);
    }
  };

  useEffect(() => {
    loadTravelQuotes(requestToken);

    return () => {
      resetTravelQuotes();
    };
  }, []);

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteTravelFromCart(quoteId, fetchQuotes, modifyData, () => updateTravelGuarantee(quoteId, [], requestToken)));
  };

  // useEffect(() => {
  //   if (insuranceRequest && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
  //     navigate('/quote/travel', {
  //       state: { requestToken },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [insuranceRequest, requestToken]);

  useEffect(() => {
    const newArr = [];

    if (processingQuote !== null) {
      processingQuote.quotation_data_travel_europeassistance.coverages.forEach((ext) => {
        if (ext.enabled === 1) {
          processingQuote.quotation_coverages.forEach((q) => {
            if (ext.coverage_id === q.guarantees_slug) {
              newArr.push(q.guarantees_slug);
            }
          });
        }
      });
    }

    setModalExtensions(newArr);
  }, [processingQuote]);

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }
    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return quoteInProccessAmount + risksTotalAmount;
  };

  const handleRequestSave = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/travel/purchase/${requestToken}`);
  };
  // useEffect(() => {
  //   travelResultSteps(quotations, setSteps);
  // }, [quotations]);

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteTravelToCart(quoteId, fetchQuotes, modifyData));
  };

  if (loading) {
    return <PageLoading />;
  }

  return error !== null ? (
    <ErrorComponent error={error} />
  ) : (
    <>
      {/* <Joyride
            steps={steps}
            run={run}
            continuous
            showBeacon={showBeacon}
            locale={{
              back: 'Indietro',
              close: 'Chiudi',
              last: 'Fine',
              next: 'Prossima',
              open: 'Apri il modale',
              restart: 'Riavvia il tour ',
              skip: 'Salta',
            }}
            styles={{
              options: joyrideOptions,
              buttonNext: {
                backgroundColor: '#00a651',
                outline: 'none',
              },
              buttonBack: {
                color: '#00a651',
                outline: 'none',
              },
              beaconInner: {
                backgroundColor: '#00a651',
              },
              beaconOuter: {
                borderColor: '#00a651',
                backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
              },
              buttonSkip: {
                outline: 'none',
              },
              buttonClose: {
                outline: 'none',
              },
            }}
            callback={(data) => handleCallbackTravelResult(data, travelResultSteps, setState)}
            showSkipButton
            showProgress
            disableScrolling
          /> */}

      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_profession_result"
        />
      )}

      <V2FontImport />
      <TravelQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <TravelSummaryCard
              insuranceRequest={insuranceRequest}
              customer={customer}
              modificaDati={modifyData}
            />
            <TravelQuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              getTotal={getTotal}
              onProcedi={() => handleRequestSave()}
              est_provvigioni={est_provvigioni}
            >
              {processingQuote?.quotation_data_travel_europeassistance.product_code === 'EA0177'
                && <ProductInformationEurope processingQuote={processingQuote} />}
              {processingQuote?.quotation_data_travel_europeassistance.product_code === 'EA0190'
                && <ProductInformationMondo processingQuote={processingQuote} />}
            </TravelQuoteCostSummaryCard>
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end">
                  {/* <div>
                        <h4>
                          Preventivi assicurazione
                          {' '}
                          <b>viaggi</b>
                        </h4>
                        <p>
                          Inizio Copertura:
                          {' '}
                          {new Date(insuranceRequest.policy_effective_date).toLocaleDateString('it-IT', { year: 'numeric', month: 'numeric', day: 'numeric' })}
                        </p>
                      </div> */}
                  {/* <div>
                        {localStorage.getItem('newResultTravel') === 'done' && (
                          <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                            <button className="btn btn-success px-2 py-1">Tutorial</button>
                          </div>
                        )}
                      </div> */}
                  <OutlineActionButton
                    type="button"
                    onClick={() => {
                      setShowConversationModal(true);
                      if (thread?.unreadMessages > 0) silentRefresh();
                    }}
                  >
                    <ChatIcon />
                    Contatta il Backoffice
                    {thread?.unreadMessages > 0 && (
                      <ActionButtonBadge>
                        {thread.unreadMessages}
                        <span className="visually-hidden">messaggi non letti</span>
                      </ActionButtonBadge>
                    )}
                  </OutlineActionButton>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotes && !quotes.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          {quotes && quotes.res_civile
            && (
              <>
                <RiskContainer className="mb-4">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotes && quotes[type.id] && (
                        <RiskCard
                          className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${insuranceRequest.processing_quotation_id === null
                            && type.id !== 'res_civile'
                            ? 'bg-secondary bg-opacity-25'
                            : ''
                          } ${insuranceRequest.processing_quotation_id !== null
                              && type.id === 'res_civile'
                            ? 'bg-success bg-opacity-25'
                            : ''
                          } ${riskQuotations && riskQuotations[type.id] !== undefined
                            ? 'bg-success bg-opacity-25'
                            : ''
                          }`}
                        >
                          <div className="me-auto">
                            <h5>{type.id == 'res_civile' ? 'Viaggi' : type.name}</h5>
                          </div>
                          {processingQuote !== null && type.id === 'res_civile' && (
                            <ProcessingQuoteSelectedTravel
                              processingQuote={processingQuote}
                              requestInfo={insuranceRequest}
                            />
                          )}

                          {/* {riskQuotations
                            && riskQuotations[type.id] === undefined
                            && type.id !== 'res_civile'
                            && processingQuote !== null && (
                              <div
                                data-bs-toggle="modal"
                                data-bs-target={`#${type.id}`}
                                style={{ cursor: 'pointer' }}
                                className="alert alert-secondary"
                              >
                                Seleziona Quotazione!
                              </div>
                          )} */}
                          <div className="d-flex justify-content-end ms-auto gap-2">
                            {type.id === 'res_civile' && processingQuote !== null && (
                              <RiskButtonRemove
                                className="btn btn-danger"
                                onClick={() => removeItemFromCart(processingQuote.id)}
                              >
                                Rimuovi
                              </RiskButtonRemove>
                            )}

                            {insuranceRequest.processing_quotation_id === null
                              && type.id !== 'res_civile' && (
                                <SelectFirstNotice>
                                  Seleziona Prima La Responsibilita Civile
                                </SelectFirstNotice>
                            )}

                            {type.id === 'res_civile' && (
                              <RiskButton
                                className="btn btn-success"
                                data-bs-toggle="modal"
                                data-bs-target={`#${type.id}`}
                              >
                                Aggiungi
                              </RiskButton>
                            )}
                            {/* {riskQuotations
                              && riskQuotations[type.id] !== undefined
                              && type.id !== 'res_civile'
                              && riskQuotations[type.id].map((quote, idx) => (
                                <React.Fragment key={idx}>
                                  {type.id === quote.quote_type && (
                                    <RiskButtonRemove
                                      className="btn btn-danger"
                                      onClick={() => removeItemFromCart(quote.id)}
                                    >
                                      Rimuovi
                                    </RiskButtonRemove>
                                  )}
                                </React.Fragment>
                              ))} */}

                            {/* {riskQuotations
                              && riskQuotations[type.id] === undefined
                              && processingQuote !== null
                              && type.id !== 'res_civile' && (
                                <RiskButton
                                  className="btn btn-success"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#${type.id}`}
                                >
                                  Aggiungi
                                </RiskButton>
                            )} */}
                            {insuranceRequest.processing_quotation_id === null
                              && type.id !== 'res_civile' && (
                                <SelectFirstNotice>
                                  Seleziona Prima La Responsibilita Civile
                                </SelectFirstNotice>
                            )}
                          </div>
                        </RiskCard>

                      )}
                    </React.Fragment>

                  ))}
                  {processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.filter((f) => f.enabled === 1).map((coverage, index) => (
                    <RiskCard
                      key={index}
                      className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${insuranceRequest.processing_quotation_id === null
                        ? 'bg-secondary bg-opacity-25'
                        : ''
                      }
                       ${processingQuote.quotation_coverages.find((el) => el.guarantees_slug === coverage.coverage_id) !== undefined
                        ? 'bg-success bg-opacity-25'
                        : ''
                        } `}
                    >
                      <div className="me-auto">
                        <h5>
                          {coverage.title}
                        </h5>
                      </div>
                      {processingQuote.quotation_coverages.find((el) => el.guarantees_slug === coverage.coverage_id) !== undefined && (
                        <div className="col-12 mb-2">
                          <GuaranteesSelectedCard
                            processingQuote={processingQuote}
                            requestInfo={insuranceRequest}
                            coverage={coverage}
                          />
                        </div>
                      )}

                      {processingQuote.quotation_coverages.find((el) => el.guarantees_slug === coverage.coverage_id) === undefined && insuranceRequest.processing_quotation_id !== null && (
                        <div
                          data-bs-toggle="modal"
                          data-bs-target={`#id_${coverage.coverage_id}`}
                          style={{ cursor: 'pointer' }}
                          className="alert alert-secondary"
                        >
                          Seleziona Quotazione!
                        </div>
                      )}

                      <div className="d-flex justify-content-end ms-auto gap-2">
                        {processingQuote.quotation_coverages.find((el) => el.guarantees_slug === coverage.coverage_id) !== undefined && (
                          <RiskButtonRemove
                            className="btn btn-danger"
                            onClick={() => {
                              if (coverage.coverage_id === '000001_EA1358' || coverage.coverage_id === '000001_EA1244') {
                                removeDataSet();
                              }

                              updateGuarantees(coverage.coverage_id);
                            }}
                          >
                            Rimuovi
                          </RiskButtonRemove>
                        )}

                        {insuranceRequest.processing_quotation_id === null && (
                          <SelectFirstNotice>
                            Seleziona Prima Viaggi
                          </SelectFirstNotice>
                        )}

                        {processingQuote.quotation_coverages.find((el) => el.guarantees_slug === coverage.coverage_id) === undefined && insuranceRequest.processing_quotation_id !== null && (
                          <RiskButton
                            className="btn btn-success"
                            data-bs-toggle="modal"
                            data-bs-target={`#id_${coverage.coverage_id}`}
                          >
                            Aggiungi
                          </RiskButton>
                        )}
                        {/* {riskQuotations
                              && riskQuotations[type.id] !== undefined
                              && type.id !== 'res_civile'
                              && riskQuotations[type.id].map((quote, idx) => (
                                <React.Fragment key={idx}>
                                  {type.id === quote.quote_type && (
                                    <RiskButtonRemove
                                      className="btn btn-danger"
                                      onClick={() => removeItemFromCart(quote.id)}
                                    >
                                      Rimuovi
                                    </RiskButtonRemove>
                                  )}
                                </React.Fragment>
                              ))} */}

                        {/* {riskQuotations
                              && riskQuotations[type.id] === undefined
                              && processingQuote !== null
                              && type.id !== 'res_civile' && (
                                <RiskButton
                                  className="btn btn-success"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#${type.id}`}
                                >
                                  Aggiungi
                                </RiskButton>
                            )} */}
                        {/* {insuranceRequest.processing_quotation_id === null
                              && type.id !== 'res_civile' && (
                                <div className="alert alert-warning py-2 px-2">
                                  Seleziona Prima La Responsibilita Civile
                                </div>
                      )} */}
                      </div>

                    </RiskCard>
                  ))}

                </RiskContainer>

                {quoteTypes.map((type, index) => (
                  <TravelModal
                    key={index}
                    type={type}
                    addingQuote={addingQuote}
                    quotes={quotes}
                    requestToken={requestToken}
                    insuranceRequest={insuranceRequest}
                    selectQuotation={selectQuotation}
                    fetchQuotes={fetchQuotes}
                  />
                ))}

                {processingQuote !== null && processingQuote.quotation_data_travel_europeassistance.coverages.filter((f) => f.enabled === 1).map((coverage, index) => (
                  <TravelCoverageModal
                    key={index}
                    coverage={coverage}
                    addingQuote={addingQuote}
                    processingQuote={processingQuote}
                    getCoveragePrice={getCoveragePrice}
                    handleGuarantees={handleGuarantees}
                    loadingDataset={loadingDataset}
                    formData={formData}
                    register={register}
                    updateDataSet={updateDataSet}
                  />
                ))}
              </>
            )}
        </div>
      </TravelQuotesStyles>
      {failedQuotations.length !== 0 && (
        <FailedQuotationsComponent failedQuotes={failedQuotations} />
      )}
    </>
  );
}

export default TravelResultPage;
